import React from "react";
import { Spinner } from "react-bootstrap";
import Modal from "../../../../Utilities/DraggableModal";
import { AgGridReact } from "ag-grid-react";
import useFetch from "../../../../Utilities/useFetch";

const AddressHistoryModal = ({ show, onHide, debtorID }) => {
  const { data: addressHistory, loading, error } = useFetch(
    show && debtorID,
    `${process.env.REACT_APP_API_URL}/Claims/GetAddressHistory`,
    "GET",
    null,
    { debtorID }
  );

  const columnDefs = [
    { 
      headerName: "Date", 
      field: "date", 
      sortable: true, 
      filter: true,
      cellRenderer: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString();
      }
    },
    { headerName: "Address", field: "address", sortable: true, filter: true },
    { headerName: "City", field: "city", sortable: true, filter: true },
    { headerName: "State", field: "state", sortable: true, filter: true },
    { headerName: "Zip", field: "zip", sortable: true, filter: true }
  ];

  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>Address History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Loading address history...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger">Failed to load address history</div>
        ) : !addressHistory || addressHistory.length === 0 ? (
          <p>No address history available</p>
        ) : (
          <div className="ag-theme-quartz" style={{ height: '300px', width: '100%' }}>
            <AgGridReact
              rowData={addressHistory}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              domLayout="normal"
              onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddressHistoryModal;